<nav mat-tab-nav-bar>
  <a
    *appAuthGuard="giftCardsOverviewPolicy"
    mat-tab-link
    routerLink="overview"
    routerLinkActive
    #over="routerLinkActive"
    [active]="over.isActive"
    >Overview</a
  >
  <a
    *appAuthGuard="giftCardsSettingsPolicy"
    mat-tab-link
    routerLink="settings"
    routerLinkActive
    #sett="routerLinkActive"
    [active]="sett.isActive"
    >Settings</a
  >
</nav>
<div class="content">
  <router-outlet></router-outlet>
</div>
